import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function FeaturedWorks() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-8">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-3">
              精選推薦
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              精選內容
            </h2>
          </div>
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}